import React from 'react';
import classNames from 'classnames';
import { getMessage } from 'util/locale';
import propTypes from 'prop-types';

import BaseTrigger from './BaseTrigger';

import { trackAction } from 'util/analytics';

const baseString = 'vra-set-primary-trigger';
const SetPrimaryTrigger = ({
  disabled,
  onClickSetPrimaryTrigger,
  scriptId
}) => {
  const classString = classNames({
    [`${baseString}`]: true
  });

  return (
    <BaseTrigger
      className={classString}
      content={getMessage('button-text__set-primary')}
      dataTestId={baseString}
      disabled={disabled}
      handler={() => { 
        trackAction(`Clicked on Set as Primary, Rx: ${scriptId}`);
        onClickSetPrimaryTrigger(scriptId);
      }}
    />
  );
};
SetPrimaryTrigger.propTypes = {
  disabled: propTypes.bool,
  onClickSetPrimaryTrigger: propTypes.func.isRequired,
  scriptId: propTypes.string.isRequired
};
export default SetPrimaryTrigger;
